import { jsxs, jsx } from "react/jsx-runtime";
import { QuizRenderer } from "../components/quiz-types/quiz-renderer.js";
import { DebugQuizId } from "../components/quiz-types/shared/debug-quiz-id.js";
import { toQuizData, LAYOUT } from "./constants.js";
function PrintQuizItem({ script, number, stepIdx = 0, compact }) {
  const quizData = toQuizData(script);
  const quizId = String(script.quizId ?? "");
  const isStep2 = stepIdx === 1;
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: "break-inside-avoid",
      style: {
        paddingBottom: isStep2 ? "24px" : `${LAYOUT.questionSpacing}px`,
        pageBreakInside: "avoid",
        position: "relative"
      },
      children: [
        /* @__PURE__ */ jsx("div", { className: "print:hidden", style: { position: "absolute", top: 0, right: 0, zIndex: 10 }, children: /* @__PURE__ */ jsx(DebugQuizId, { quizId }) }),
        /* @__PURE__ */ jsx(
          "div",
          {
            className: "print-quiz-wrapper",
            style: { display: "flex", justifyContent: "center" },
            children: /* @__PURE__ */ jsx("div", { style: {
              width: "100%",
              maxWidth: 650,
              ...isStep2 && {
                border: "2px solid #E6E6E6",
                borderRadius: "16px",
                padding: "20px 16px 32px 16px"
              }
            }, children: /* @__PURE__ */ jsx(
              QuizRenderer,
              {
                quizType: quizData.type,
                quizId,
                quiz: quizData,
                mode: "print",
                number,
                hideSubmitButton: true,
                disableSound: true,
                compact
              },
              quizId
            ) })
          }
        )
      ]
    }
  );
}
export {
  PrintQuizItem
};
//# sourceMappingURL=PrintQuizItem.js.map
